import { CurrentUrlContext } from '@repo/ui/src/context/CurrentUrlProvider';
import { useContext } from 'react';

const useCurrentUrl = () => useContext(CurrentUrlContext);

export default useCurrentUrl;
